var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-back",
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17136 15.873L8.87508 15.1577C9.04164 14.9883 9.04164 14.7138 8.87508 14.5445L2.45246 8L8.87508 1.45553C9.04164 1.28622 9.04164 1.01169 8.87508 0.842348L8.17136 0.126984C8.00481 -0.0423279 7.73475 -0.0423279 7.56816 0.126984L0.124916 7.69339C-0.041639 7.8627 -0.041639 8.13723 0.124916 8.30658L7.56816 15.873C7.73475 16.0423 8.00481 16.0423 8.17136 15.873Z",
    fill: "#00B0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.c73cd8ba282a79e80f45c97a4f060ff5.svg";
export { ForwardRef as ReactComponent };